import request from 'utils/request'
import { MCBQS020InitRequest } from 'types/MCBQS020/MCBQS020InitRequest'
import { MCBQS020RunningProcessRequest } from 'types/MCBQS020/MCBQS020RunningProcessRequest'

// 初期表示処理
export const initRequest = (apidata: MCBQS020InitRequest) =>
    request({
        url: '/MCBQS020/init',
        method: 'post',
        data: apidata,
})

// 選考ファイル
export const selectionFileRequest = (apidata: MCBQS020RunningProcessRequest) =>
  request({
    url: `/MCBQS020/selectionFile`,
    method: 'post',
    data:apidata,
})

// MCBファイル
export const mcbFileRequest = (apidata: MCBQS020RunningProcessRequest) =>
  request({
    url: `/MCBQS020/mcbFile`,
    method: 'post',
    data:apidata,
})

// 応募者詳細PDF
export const applicantDetailRequest = (apidata: MCBQS020RunningProcessRequest) =>
  request({
    url: `/MCBQS020/applicantDetail`,
    method: 'post',
    data:apidata,
})

// SHLテスト結果
export const shlTestResultRequest = (apidata: MCBQS020RunningProcessRequest) =>
  request({
    url: `/MCBQS020/shlTestResult`,
    method: 'post',
    data:apidata,
})

// PDFマージ
export const pdfMergeRequest = (apidata: MCBQS020RunningProcessRequest) =>
  request({
    url: `/MCBQS020/pdfMerge`,
    method: 'post',
    data:apidata,
})